/* unplugin-vue-components disabled */import script from "./UploadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadModal.vue?vue&type=script&setup=true&lang=js"

import "./UploadModal.vue?vue&type=style&index=0&id=7ce77170&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ce77170"]])

export default __exports__